import { FC } from 'react';
import Spinner from '@glomopay/shadcn/spinner';

type LoadingScreenProps = {
  message: string;
  testId: string;
};

export const LoadingScreen: FC<LoadingScreenProps> = ({ message, testId }) => {
  return (
    <main className='bg-bg-default flex min-h-dvh flex-col items-center justify-center gap-4 px-6 text-center' data-testid={testId}>
      <Spinner />
      <p className='text-text-secondary'>{message}</p>
    </main>
  );
};
